import React, { useState, useEffect, useCallback, useRef } from "react";
import {
  FaExchangeAlt, FaMapMarkerAlt, FaUniversity, FaLayerGroup, FaSyncAlt,
  FaTimesCircle, FaUsers, FaBuilding, FaBook, FaHardHat, FaChalkboardTeacher,
  FaFileAlt, FaUpload, FaEye, FaCreditCard, FaCheckCircle, FaClipboardCheck,
  FaShieldAlt,
} from "react-icons/fa";
import InstitutionInfo from "./InstitutionInfo";
import CourseIntakeDetails from "./ProgrammeIntake/CourseIntakeDetails";
import InfrastructureForm from "./InfraStructureDetails";
import StaffDetails from "./StaffDetails";
import ChangeOfInstName from "./ChangeOfInstName";
import MergerOfInstitutions from "./MergerOfInstitutions";
import TypeConversion from "./TypeConversion";
import CloserOfInstitution from "./CloserOfInstitution";
import ChangeOfLocation from "./ChangeOfLocation";
import TrustSocNameChange from "./TrustSocNameChange";
//import ProgramIntakeTabs from "./ProgrammeIntake/ProgramIntakeTabs";
import Document from "./Document";
import { config } from "../CommonUtils/CommonURLS";
import { CommonAxiosGet } from "../CommonUtils/CommonAxios";
import PreviewandPrint from "./PreviewandPrint";
import PaymentForm from "./Payment";
import DegreeInfraTabs from "./DegreeInfra/DegreeInfraTabs";
import EOP from "./DegreeInfra/EOP";
import CorpusApplication from "./DegreeInfra/CorpusApplication";
import ManagementApplication from "./ManagementApplication";
import PaymentReceipt from "./PaymentReceipt";
import { useNavigate } from "react-router-dom";
//import IntakeTabs from "./PolyTechProgramIntake/IntakeTabs";
// import DeficienciesIdentifiedService from "./UniversityScreens/DeficienciesIdentifiedService";

/* ─────────────────────────────────────────────────────────────
   noc_type from payment API  →  service card title
───────────────────────────────────────────────────────────── */
const NOC_TYPE_MAP = {
  eop: "Extension of Permission (EoP)",
  shifting: "Shifting of the Institution",
  change_of_inst_name: "Change of Institution Name",
  merge_of_instructions: "Merger of Institutions",
  type_conversions: "Conversion of the Institution",
  closure_of_institutions: "Closure of Institution",
  society_name_change: "Trust / Society Name Change",
  intake_changes: "New Programme / Section Changes",
  management: "Management Change",
};

/* ─────────────────────────────────────────────────────────────
   Per-service: appform API key + sidebar label
───────────────────────────────────────────────────────────── */
const SERVICE_META = {
  "Extension of Permission (EoP)": { appformKey: "eop_aplication_form", appformLabel: "EoP Application Form" },
  "Shifting of the Institution": { appformKey: "inst_shifting", appformLabel: "Shifting Application Form" },
  "Change of Institution Name": { appformKey: "change_inst_name", appformLabel: "Name Change Form" },
  "Merger of Institutions": { appformKey: "merger_inst", appformLabel: "Merger Application Form" },
  "Conversion of the Institution": { appformKey: "converion_inst", appformLabel: "Conversion Form" },
  "Closure of Institution": { appformKey: "closure_inst", appformLabel: "Closure Application Form" },
  "Trust / Society Name Change": { appformKey: "trust_society_namechnage", appformLabel: "Society Name Change Form" },
  "New Programme / Section Changes": { appformKey: "intake_variation", appformLabel: "Intake Variation Form" },
  "Management Change": { appformKey: "management_change", appformLabel: "Management Change Form" },
  "New College ": { appformKey: null, appformLabel: "Application Form" },
};

const SERVICE_CARDS = [
  { title: "Extension of Permission (EoP)", desc: "Apply for Extension of Permission (EOP) to continue the existing courses or institution for the upcoming academic year", icon: <FaBuilding />, color: "#160d96", bg: "#b7c0c7", tag: "Approval" },
  { title: "Shifting of the Institution", desc: "Shift institution premises to a new site or address", icon: <FaMapMarkerAlt />, color: "#0d9e76", bg: "#e6f6f2", tag: "Physical" },
  { title: "Management Change", desc: "Submit a request to update or transfer the management of the institution to a new governing body or authority", icon: <FaBuilding />, color: "#192007", bg: "#cae3f5", tag: "Management" },
  { title: "Change of Institution Name", desc: "Submit request to officially rename the institution", icon: <FaUniversity />, color: "#8b46c9", bg: "#f3ebfd", tag: "Identity" },
  { title: "New Programme / Section Changes", desc: "Modify course intake capacity and programme offerings", icon: <FaExchangeAlt />, color: "#2563eb", bg: "#eef3fe", tag: "Academic" },
  { title: "Merger of Institutions", desc: "Merge two or more institutions under a single entity", icon: <FaLayerGroup />, color: "#d96119", bg: "#fdf0e8", tag: "Structural" },
  { title: "Conversion of the Institution", desc: "Convert between Women-only and Co-Education institution", icon: <FaSyncAlt />, color: "#d63039", bg: "#fdeaea", tag: "Category" },
  { title: "Closure of Institution", desc: "Initiate formal closure proceedings for an institution", icon: <FaTimesCircle />, color: "#c08a10", bg: "#fdf6e3", tag: "Closure" },
  { title: "Trust / Society Name Change", desc: "Update the name of the managing trust or society body", icon: <FaUsers />, color: "#0b8fbd", bg: "#e3f6fd", tag: "Management" },
  { title: "New College ", desc: "Apply for the establishment of a new college", icon: <FaBuilding />, color: "#1565c0", bg: "#e3f2fd", tag: "Establishment" },
];

const STEPS = [
  { id: "inst", label: "Institute Details", icon: <FaBuilding />, groupColor: "#1565c0" },
  { id: "course", label: "Course Intake Details", icon: <FaBook />, groupColor: "#1565c0" },
  { id: "infra", label: "Infrastructure", icon: <FaHardHat />, groupColor: "#1565c0" },
  { id: "staff", label: "Staff Details", icon: <FaChalkboardTeacher />, groupColor: "#1565c0" },
  { id: "corpus", label: "Corpus Fund Details", icon: <FaUniversity />, groupColor: "#1565c0" },
  { id: "appform", label: "Application Form", icon: <FaFileAlt />, groupColor: "#7b2ff7" },
  { id: "docs", label: "Upload Documents", icon: <FaUpload />, groupColor: "#7b2ff7" },
  { id: "preview", label: "Preview", icon: <FaEye />, groupColor: "#7b2ff7" },

  { id: "payment", label: "Payment", icon: <FaCreditCard />, groupColor: "#7b2ff7" },


];


/* ═══════════════════════════════════════════════════════════
   MAIN COMPONENT
═══════════════════════════════════════════════════════════ */
export default function ServiceCards() {
  const Clg = sessionStorage?.getItem("LOGIN");
  const SERVICE_FORM_MAP = {
    // "New Programme / Section Changes": ProgramIntakeTabs,
    // "New Programme / Section Changes": Clg === "degree" ? IntakeTabs : ProgramIntakeTabs,

    "Shifting of the Institution": ChangeOfLocation,
    "Change of Institution Name": ChangeOfInstName,
    "Merger of Institutions": MergerOfInstitutions,
    "Conversion of the Institution": TypeConversion,
    "Closure of Institution": CloserOfInstitution,
    "Trust / Society Name Change": TrustSocNameChange,
    "Extension of Permission (EoP)": CorpusApplication,
    "Management Change": ManagementApplication,
  };
  let navigate = useNavigate();
  const [activeCard, setActiveCard] = useState(null);
  const [currentStep, setCurrentStep] = useState(0);
  const [visible, setVisible] = useState(false);
  const [apiData, setApiData] = useState({});
  const [paymentDetails, setPaymentDetails] = useState([]);

  /* Keep a ref so we can call inside goNext without stale closure */
  const activeCardRef = useRef(null);
  activeCardRef.current = activeCard;
  const serviceKeyMap = {
    "Merger of Institutions": "merge_ofinstructions",
    "Conversion of the Institution": "type_converstions",
    "Closure of Institution": "closure_of_institutions",
    "Trust / Society Name Change": "society_name_change",
    "Programme / Intake Changes": "intake_changes",
    "Shifting of the Institution": "shifting",
    "Change of Institution Name": "change_of_inst_name",
    "Extension of Permission (EoP)": "eop",
    "Management Change": "management",
  };
  const shortServiceKey = serviceKeyMap[activeCard] ?? "";



  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 60);
    return () => clearTimeout(t);
  }, []);

  /* ── API calls ── */
  const GetServiceCompleted = useCallback(() => {
    CommonAxiosGet(`${config.url.FAC_URL}getServicesDone`).then((res) => {
      if (res?.data?.scode === "01") {
        setApiData(res.data.count?.[0] || {});
      }
    });
  }, []);

  const GetPaymentDtls = useCallback((key) => {
    CommonAxiosGet(config.url.FAC_URL + "paymentDetails/" + key).then((res) => {
      if (res?.data?.scode === "01") {
        setPaymentDetails(res?.data?.paymentDetails || []);
      }
      else {
        setPaymentDetails([]);
      }
    });
  }, []);
  const [docCount, setDocCount] = useState([]);
  const DocumentsCompletedStatus = useCallback((key) => {
    CommonAxiosGet(`${config.url.FAC_URL}getDocumentsDone/${key}`).then((res) => {
      if (res?.data?.scode === "01" || res?.data?.status === true) {
        console.log("STATUS>>>>>>>>", res?.data?.data[0]?.count)
        setDocCount(res?.data?.data[0]?.count || {});
      }
    });
  }, []);

  const isPaymentDone = Array.isArray(paymentDetails) && paymentDetails.length > 0;
  console.log("Payment details", paymentDetails, "isPaymentDone", isPaymentDone);
  useEffect(() => {
    if (activeCard) {
      const key = serviceKeyMap[activeCard] ?? "";
      GetServiceCompleted();
      GetPaymentDtls(key);
      DocumentsCompletedStatus(key);
    }
  }, [activeCard]);

  /* ── Derived values ── */
  const isInfraCompleted =
    apiData.soc_land_details === 1 &&
    apiData.buildblock_details === 1 &&
    apiData.instructional_area === 1 &&
    apiData.college_facilities === 1 &&
    apiData.lab_area_details === 1 &&
    apiData.other_infra === 1;

  // const paidServiceTitle = paymentDetails?.noc_type
  //   ? NOC_TYPE_MAP[paymentDetails.noc_type] || null
  //   : null;
  // const isCurrentServicePaid = paidServiceTitle === activeCard;
  const paidServiceTitle = Array.isArray(paymentDetails)
    ? paymentDetails.some(
      (p) => p?.noc_type && NOC_TYPE_MAP[p.noc_type] === activeCard
    )
      ? activeCard
      : null
    : null;

  const isCurrentServicePaid = paidServiceTitle === activeCard;
  const paymentDone = isCurrentServicePaid;

  /* ── Dynamic appform done: checks the correct API key per active service ── */
  const getAppFormDone = useCallback(() => {
    if (!activeCard) return false;
    const meta = SERVICE_META[activeCard];
    if (!meta?.appformKey) return true; // New College has no appform
    return apiData[meta.appformKey] === 1;
  }, [activeCard, apiData]);



  const infraTabs = [
    { label: "Land Allocation", key: "soc_land_details" },
    { label: "Building Block Details", key: "buildblock_details" },
    { label: "Instructional Area", key: "instructional_area" },
    { label: "College Facilities", key: "college_facilities" },
    { label: "Lab Area Details", key: "lab_area_details" },
    { label: "Other Infrastructure", key: "other_infra" },
  ];

  const getInfraStatusList = () =>
    infraTabs.map((t) => ({ name: t.label, done: apiData?.[t.key] === 1 }));

  /*
    STEP_DONE_FROM_API — single source of truth for sidebar ✅
    appform uses getAppFormDone() so it's dynamic per service.
  */
  const STEP_DONE_FROM_API = {
    inst: apiData?.inst_details === 1,
    course: apiData?.course_intake_details === 1,
    infra: isInfraCompleted,
    staff: apiData?.staff_details === 1,
    corpus: apiData?.eop === 1,
    appform: getAppFormDone(),
    docs: docCount > 0,

    preview: false,
    payment: isPaymentDone,
    // Deficiency: apiData?.deficiency === 1, // ✅ ADD THIS

  };

  /* Filtered + relabelled steps */
  const FILTERED_STEPS = STEPS
    .filter((s) => s.id !== "corpus" || Clg === "degree")
    .map((s) =>
      s.id === "appform" && activeCard && SERVICE_META[activeCard]?.appformLabel
        ? { ...s, label: SERVICE_META[activeCard].appformLabel }
        : s
    );

  /* Incomplete steps for payment gate */
  const getIncompleteStepsList = () => {
    const list = [];
    if (!STEP_DONE_FROM_API.inst) list.push("Institute Details");
    if (!STEP_DONE_FROM_API.course) list.push("Course Intake Details");
    if (!STEP_DONE_FROM_API.infra) list.push("Infrastructure");
    if (!STEP_DONE_FROM_API.staff) list.push("Staff Details");
    if (Clg === "degree" && !STEP_DONE_FROM_API.corpus) list.push("Corpus Fund Details");
    if (!STEP_DONE_FROM_API.appform)
      list.push(SERVICE_META[activeCard]?.appformLabel || "Application Form");
    if (!STEP_DONE_FROM_API.docs) list.push("Document Upload");
    return list;
  };

  const incompleteSteps = getIncompleteStepsList();
  const isReady = incompleteSteps.length === 0;

  /* ── Navigation ── */
  const openService = (card) => { setActiveCard(card.title); setCurrentStep(0); };
  const backToMainServices = () => { setActiveCard(null); setCurrentStep(0); };

  const goNext = () => {
    if (currentStep < FILTERED_STEPS.length - 1) {
      const next = currentStep + 1;
      setCurrentStep(next);
      if (FILTERED_STEPS[next]?.id === "payment") {
        GetServiceCompleted();
      }
    }
  };

  const goPrev = () => { if (currentStep > 0) setCurrentStep((s) => s - 1); };

  const jumpTo = (i) => {
    setCurrentStep(i);
    GetServiceCompleted();
  };

  const isLast = currentStep === FILTERED_STEPS.length - 1;
  const selected = SERVICE_CARDS.find((c) => c.title === activeCard);

  /* ────────────────────────────────────────────────────
     COMPLETION STATUS SCREEN
  ───────────────────────────────────────────────────── */
  const renderCompletionStatus = () => {
    const relevantSteps = FILTERED_STEPS.filter((s) => !["preview", "payment"].includes(s.id));
    const doneCount = relevantSteps.filter((s) => STEP_DONE_FROM_API[s.id]).length;
    const total = relevantSteps.length;
    const pct = Math.round((doneCount / total) * 100);

    const Row = ({ label, done }) => (
      <div style={{
        display: "flex", alignItems: "center", justifyContent: "space-between",
        padding: "11px 16px",
        borderBottom: "0.5px solid var(--color-border-tertiary)",
      }}>
        <span style={{ display: "flex", alignItems: "center", gap: 10, fontSize: 13, color: "var(--color-text-primary)" }}>
          <span style={{
            width: 18, height: 18, borderRadius: "50%",
            background: done ? "#E1F5EE" : "#FEF3F2",
            border: `1.5px solid ${done ? "#1D9E75" : "#D85A30"}`,
            display: "inline-flex", alignItems: "center", justifyContent: "center", flexShrink: 0,
          }}>
            {done
              ? <svg width="9" height="9" viewBox="0 0 9 9"><polyline points="1.5,4.5 3.5,6.5 7.5,2.5" fill="none" stroke="#1D9E75" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" /></svg>
              : <svg width="8" height="8" viewBox="0 0 8 8"><line x1="2" y1="2" x2="6" y2="6" stroke="#D85A30" strokeWidth="1.5" strokeLinecap="round" /><line x1="6" y1="2" x2="2" y2="6" stroke="#D85A30" strokeWidth="1.5" strokeLinecap="round" /></svg>
            }
          </span>
          {label}
        </span>
        <span style={{
          fontSize: 11, padding: "3px 12px", borderRadius: 20, fontWeight: 500,
          background: done ? "#E1F5EE" : "#FEF3F2",
          color: done ? "#0F6E56" : "#993C1D",
          border: `1px solid ${done ? "#9FE1CB" : "#F5C4B3"}`,
        }}>
          {done ? "✓ Completed" : "Pending"}
        </span>
      </div>
    );

    return (
      <div style={{ padding: "4px 2px 1rem" }}>

        {/* Hero card */}
        <div style={{
          position: "relative", overflow: "hidden",
          marginBottom: "1.5rem", padding: "1.5rem",
          background: "linear-gradient(135deg, #1a237e 0%, #283593 60%, #3949ab 100%)",
          borderRadius: 16, color: "#fff",
        }}>
          <div style={{ position: "absolute", right: -30, top: -30, width: 140, height: 140, borderRadius: "50%", background: "rgba(255,255,255,0.06)" }} />
          <div style={{ position: "absolute", right: 40, bottom: -50, width: 180, height: 180, borderRadius: "50%", background: "rgba(255,255,255,0.04)" }} />

          <div style={{ display: "flex", alignItems: "flex-start", gap: 16, position: "relative" }}>
            <div style={{ width: 52, height: 52, borderRadius: "50%", background: "rgba(255,255,255,0.15)", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
              <FaClipboardCheck style={{ fontSize: 22, color: "#fff" }} />
            </div>
            <div style={{ flex: 1 }}>
              <h2 style={{ fontSize: 20, fontWeight: 600, color: "#fff", margin: 0 }}>Application Completion Status</h2>
              <p style={{ fontSize: 13, color: "rgba(255,255,255,0.75)", marginTop: 4, marginBottom: 16 }}>
                Complete all pending steps before proceeding to payment
              </p>
              <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                <div style={{ flex: 1, height: 8, background: "rgba(255,255,255,0.2)", borderRadius: 4, overflow: "hidden" }}>
                  <div style={{
                    height: "100%", borderRadius: 4,
                    background: pct === 100 ? "#4ade80" : "#60a5fa",
                    width: `${pct}%`, transition: "width 0.5s ease",
                  }} />
                </div>
                <span style={{ fontSize: 13, fontWeight: 600, color: "#fff", minWidth: 40 }}>{pct}%</span>
              </div>
              <p style={{ fontSize: 12, color: "rgba(255,255,255,0.65)", marginTop: 6 }}>
                {doneCount} of {total} steps completed
              </p>
            </div>
          </div>

          <div style={{ display: "flex", gap: 8, marginTop: 16, flexWrap: "wrap", position: "relative" }}>
            <div style={{ padding: "4px 14px", borderRadius: 20, background: "rgba(255,255,255,0.15)", fontSize: 12, color: "#fff", border: "1px solid rgba(255,255,255,0.25)" }}>
              {doneCount} Completed
            </div>
            <div style={{ padding: "4px 14px", borderRadius: 20, background: "rgba(239,99,39,0.3)", fontSize: 12, color: "#ffd0b8", border: "1px solid rgba(239,99,39,0.4)" }}>
              {total - doneCount} Remaining
            </div>
          </div>
        </div>

        {/* Application steps card */}
        <div style={{ marginBottom: "1.25rem" }}>
          <div style={{
            display: "flex", alignItems: "center", justifyContent: "space-between",
            padding: "12px 16px", marginBottom: 2,
            background: "var(--color-background-secondary)",
            borderRadius: "12px 12px 0 0",
            border: "0.5px solid var(--color-border-tertiary)",
            borderTopWidth: 3, borderTopColor: "#378ADD",
          }}>
            <span style={{ fontSize: 13, fontWeight: 600, color: "var(--color-text-primary)", display: "flex", alignItems: "center", gap: 8 }}>
              <FaFileAlt style={{ color: "#378ADD", fontSize: 14 }} />
              Application Steps
            </span>
            {incompleteSteps.length > 0 ? (
              <span style={{ fontSize: 11, padding: "3px 12px", borderRadius: 20, fontWeight: 500, background: "#FEF3F2", color: "#993C1D", border: "1px solid #F5C4B3" }}>
                {incompleteSteps.length} Pending
              </span>
            ) : (
              <span style={{ fontSize: 11, padding: "3px 12px", borderRadius: 20, fontWeight: 500, background: "#E1F5EE", color: "#0F6E56", border: "1px solid #9FE1CB" }}>
                All Done
              </span>
            )}
          </div>
          <div style={{ background: "var(--color-background-primary)", border: "0.5px solid var(--color-border-tertiary)", borderTop: "none", borderRadius: "0 0 12px 12px", overflow: "hidden" }}>
            <Row label="Institute Details" done={STEP_DONE_FROM_API.inst} />
            <Row label="Course Intake Details" done={STEP_DONE_FROM_API.course} />
            <Row label="Staff Details" done={STEP_DONE_FROM_API.staff} />
            {Clg === "degree" && <Row label="Corpus Fund Details" done={STEP_DONE_FROM_API.corpus} />}
            {/* ✅ Dynamic appform label + status per active service */}
            <Row
              label={SERVICE_META[activeCard]?.appformLabel || "Application Form"}
              done={STEP_DONE_FROM_API.appform}
            />
            <div style={{ borderBottom: "none" }}>
              <Row label="Document Upload" done={STEP_DONE_FROM_API.docs} />
            </div>
          </div>
        </div>

        {/* Infrastructure card */}
        <div style={{ marginBottom: "1.25rem" }}>
          <div style={{
            display: "flex", alignItems: "center", justifyContent: "space-between",
            padding: "12px 16px", marginBottom: 2,
            background: "var(--color-background-secondary)",
            borderRadius: "12px 12px 0 0",
            border: "0.5px solid var(--color-border-tertiary)",
            borderTopWidth: 3, borderTopColor: isInfraCompleted ? "#1D9E75" : "#EF9F27",
          }}>
            <span style={{ fontSize: 13, fontWeight: 600, color: "var(--color-text-primary)", display: "flex", alignItems: "center", gap: 8 }}>
              <FaHardHat style={{ color: isInfraCompleted ? "#1D9E75" : "#EF9F27", fontSize: 14 }} />
              Infrastructure Details
            </span>
            <span style={{
              fontSize: 11, padding: "3px 12px", borderRadius: 20, fontWeight: 500,
              background: isInfraCompleted ? "#E1F5EE" : "#FEF3F2",
              color: isInfraCompleted ? "#0F6E56" : "#993C1D",
              border: `1px solid ${isInfraCompleted ? "#9FE1CB" : "#F5C4B3"}`,
            }}>
              {isInfraCompleted ? "✓ Completed" : "Pending"}
            </span>
          </div>
          <div style={{ background: "var(--color-background-primary)", border: "0.5px solid var(--color-border-tertiary)", borderTop: "none", borderRadius: "0 0 12px 12px", overflow: "hidden" }}>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr" }}>
              {getInfraStatusList().map((item, i, arr) => (
                <div key={item.name} style={{
                  padding: "11px 16px", fontSize: 13,
                  borderBottom: i >= arr.length - 2 ? "none" : "0.5px solid var(--color-border-tertiary)",
                  borderRight: i % 2 === 1 ? "none" : "0.5px solid var(--color-border-tertiary)",
                  display: "flex", alignItems: "center", justifyContent: "space-between", gap: 8,
                }}>
                  <span style={{ color: "var(--color-text-primary)", fontSize: 12 }}>{item.name}</span>
                  <span style={{
                    fontSize: 10, padding: "2px 10px", borderRadius: 20, fontWeight: 500, whiteSpace: "nowrap",
                    background: item.done ? "#E1F5EE" : "#FEF3F2",
                    color: item.done ? "#0F6E56" : "#993C1D",
                    border: `1px solid ${item.done ? "#9FE1CB" : "#F5C4B3"}`,
                  }}>
                    {item.done ? "✓ Completed" : "Pending"}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Hint */}
        {!isReady && (
          <div style={{
            display: "flex", alignItems: "center", gap: 10,
            fontSize: 13, color: "#7c5700", padding: "12px 16px",
            background: "#FFFBEB", borderRadius: 10, border: "1px solid #FDE68A",
          }}>
            <span style={{ fontSize: 18 }}>⚠</span>
            Please complete all pending steps above to unlock the payment option.
          </div>
        )}
      </div>
    );
  };

  /* ─────────────────────────────────────────────────────────
     Content renderer
  ───────────────────────────────────────────────────────── */
  // const renderContent = () => {
  //   const stepId = FILTERED_STEPS[currentStep]?.id;

  //   switch (stepId) {
  //     case "inst":
  //       return <InstitutionInfo goNext={goNext} paymentDone={paymentDone} />;

  //     case "course":
  //       return <CourseIntakeDetails goNext={goNext} paymentDone={paymentDone} />;

  //     // case "infra":
  //     //   return Clg === "degree"
  //     //     ? <DegreeInfraTabs statusList={getInfraStatusList()} paymentDone={paymentDone} />
  //     //     : <InfrastructureForm goNext={goNext} paymentDone={paymentDone} />;
  //     // In ServiceCards.jsx — find where you render DegreeInfraTabs (inside renderContent)
  //     case "infra":
  //       return Clg === "degree"
  //         ? <DegreeInfraTabs
  //           statusList={getInfraStatusList()}
  //           paymentDone={paymentDone}
  //           onStepSaved={GetServiceCompleted}  // ← add this
  //         />
  //         : <InfrastructureForm goNext={goNext} paymentDone={paymentDone} />;

  //     case "staff":
  //       return <StaffDetails goNext={goNext} paymentDone={paymentDone} />;

  //     case "corpus":
  //       return <EOP goNext={goNext} paymentDone={paymentDone} />;

  //     case "appform": {
  //       if (activeCard === "New College ") { goNext(); return null; }
  //       const FormComponent = SERVICE_FORM_MAP[activeCard];
  //       return FormComponent
  //         ? <FormComponent serviceTitle={activeCard} paymentDone={paymentDone} />
  //         : <div>No form found for this service.</div>;
  //     }

  //     case "docs":
  //       return (
  //         <Document
  //           serviceTitle={activeCard}
  //           goNext={goNext}
  //           paymentDone={paymentDone}
  //         />
  //       );

  //     case "preview":
  //       return (
  //         <PreviewandPrint
  //           accentColor={selected?.color}
  //           service={activeCard}
  //           paymentDone={paymentDone}
  //         />
  //       );

  //       // case "payment":
  //       if (isCurrentServicePaid) {
  //         return <PaymentReceipt ac={activeCard} />;
  //       }
  //       if (!isReady) {
  //         return renderCompletionStatus();
  //       }
  //       return (
  //         <PaymentForm
  //           accentColor={selected?.color}
  //           serviceTitle={activeCard}
  //           goNext={goNext}
  //           paymentDone={paymentDone}
  //         />
  //       );


  //     case "payment":
  //       // if (isCurrentServicePaid) {
  //       //   // ✅ Find the matching payment record for THIS service
  //       //   const receipt = Array.isArray(paymentDetails)
  //       //     ? paymentDetails.find(
  //       //       (p) => NOC_TYPE_MAP[p?.noc_type] === activeCard
  //       //     )
  //       //     : null;
  //       //   return <PaymentReceipt paymentData={receipt} />;
  //       // }

  //       if (isCurrentServicePaid) {
  //         // ✅ Find the matching payment record for THIS service
  //         const receipt = Array.isArray(paymentDetails)
  //           ? paymentDetails.find(
  //             (p) => NOC_TYPE_MAP[p?.noc_type] === activeCard
  //           )
  //           : null;

  //         // Pass both activeCard and receipt to PaymentReceipt
  //         return <PaymentReceipt ac={activeCard} paymentData={receipt} />;
  //       }
  //       if (!isReady) {
  //         return renderCompletionStatus();
  //       }
  //       return (
  //         <PaymentForm
  //           accentColor={selected?.color}
  //           serviceTitle={activeCard}
  //           goNext={goNext}
  //           paymentDone={paymentDone}
  //         />
  //       );
  //     default:
  //       return null;
  //   }
  // };




  const renderContent = () => {
    const stepId = FILTERED_STEPS[currentStep]?.id;

    switch (stepId) {
      case "inst":
        return <InstitutionInfo goNext={goNext} paymentDone={paymentDone} />;

      case "course":
        return <CourseIntakeDetails goNext={goNext} paymentDone={paymentDone} />;

      case "infra":
        return Clg === "degree"
          ? <DegreeInfraTabs
            statusList={getInfraStatusList()}
            paymentDone={paymentDone}
            onStepSaved={GetServiceCompleted}
          />
          : <InfrastructureForm goNext={goNext} paymentDone={paymentDone} />;

      case "staff":
        return <StaffDetails goNext={goNext} paymentDone={paymentDone} />;

      case "corpus":
        return <EOP goNext={goNext} paymentDone={paymentDone} />;

      case "appform": {
        if (activeCard === "New College ") { goNext(); return null; }
        const FormComponent = SERVICE_FORM_MAP[activeCard];

        return FormComponent
          ? <FormComponent serviceTitle={activeCard} paymentDone={paymentDone} goNext={goNext} />
          : <div>No form found for this service.</div>;
      }

      case "docs":
        return (
          <Document
            serviceTitle={activeCard}
            goNext={goNext}
            paymentDone={paymentDone}
          />
        );

      case "preview":
        return (
          <PreviewandPrint
            accentColor={selected?.color}
            service={activeCard}
            paymentDone={paymentDone}
          />
        );

      case "payment": {
        if (isCurrentServicePaid) {
          // Find the matching payment record for THIS service
          const receipt = Array.isArray(paymentDetails)
            ? paymentDetails.find(
              (p) => NOC_TYPE_MAP[p?.noc_type] === activeCard
            )
            : null;

          // Pass both activeCard and receipt to PaymentReceipt
          return <PaymentReceipt ac={activeCard} paymentData={receipt} />;
        }

        if (!isReady) {
          return renderCompletionStatus();
        }

        return (
          <PaymentForm
            accentColor={selected?.color}
            serviceTitle={activeCard}
            goNext={goNext}
            paymentDone={paymentDone}
          />
        );
      }

      // case "Deficiency":
      //   return (
      //     <DeficienciesIdentifiedService
      //       serviceTitle={activeCard}
      //       paymentDone={paymentDone}
      //       goNext={goNext}
      //     />
      //   );

      default:
        return null;
    }
  };

  /* ─────────────────────────────────────────────────────────
     Bottom nav — Next button
     ✅ No isCurrentServicePaid condition — always shows Prev/Next
  ───────────────────────────────────────────────────────── */
  // const renderNextButton = () => {
  //   if (isLast) {
  //     return (
  //       <p
  //         // className="flow-nav-next"
  //         style={{ color: "#0d9e76", fontSize: 14, fontWeight: 500, display: "flex", alignItems: "center", gap: 6, cursor: "pointer" }}
  //         onClick={goNext}
  //       >
  //         <FaClipboardCheck style={{ marginRight: 6 }} />  Application Submitted
  //       </p>
  //     );
  //   }
  //   return (
  //     <button
  //       className="flow-nav-next"
  //       style={{ background: selected?.color }}
  //       onClick={goNext}
  //     >
  //       Next →
  //     </button>
  //   );
  // };


  const renderNextButton = () => {
    const isPaymentDone =
      Array.isArray(paymentDetails) && paymentDetails.length > 0;

    // ✅ Last step + payment done → show submitted text with tick (NOT clickable)
    if (isLast && isPaymentDone) {
      return (
        <span
          style={{
            color: "#0d9e76",
            fontSize: 14,
            fontWeight: 500,
            display: "flex",
            alignItems: "center",
            gap: 6
          }}
        >
          <FaClipboardCheck style={{ marginRight: 6 }} />
          Application Submitted
        </span>
      );
    }

    // ❌ Last step + payment NOT done → show nothing
    if (isLast && !isPaymentDone) {
      return null;
    }

    // ⏭️ बाकी steps → Next button
    return (
      <button
        className="flow-nav-next"
        style={{ background: selected?.color }}
        onClick={goNext}
      >
        Next →
      </button>
    );
  };







  const allowedCards =
    Clg === "degree"
      ? [
        "Extension of Permission (EoP)",
        "Shifting of the Institution",
        "Management Change",
        // "New Programme / Section Changes",
        // "Change of Institution Name",


      ]
      : [
        "Shifting of the Institution",
        "Management Change",
        "Change of Institution Name",
        "New Programme / Section Changes",
        "Merger of Institutions",
        "Conversion of the Institution",
        "Closure of Institution",
        "Trust / Society Name Change",
        "New College",
      ];

  const isCardClickable = (title) => allowedCards.includes(title.trim());
  const filteredCards = SERVICE_CARDS.filter((c) =>
    allowedCards.includes(c.title.trim())
  );

  if (!activeCard)
    return (
      <div className="sc-root">
        <div className="sc-welcome">
          <div className="sc-welcome-left">
            <div className="sc-welcome-badge">NOC Portal</div>
            <h2 className="sc-welcome-title">Welcome to Services</h2>
            <p className="sc-welcome-sub">
              Select a service to begin. Each service walks you through institute profile,
              application form, document upload, and payment.
            </p>
          </div>


          <div className="sc-welcome-stat">
            <div className="sc-stat-pill">
              <span className="sc-stat-num">3</span>
              <span className="sc-stat-lbl">Services Available</span>
            </div>
          </div>
        </div>

        {/* <div className="sc-section-hdr">
          <div className="sc-section-title">
            <span className="sc-title-bar" />Select a Service to Proceed
          </div>
        </div> */}
        <div className="sc-section-hdr">

          {/* Left Title */}
          <div className="sc-section-title">
            <span className="sc-title-bar" />
            Select a Service to Proceed
          </div>

          {/* Right Side Buttons */}
          <div className="sc-header-actions">

            <div
              className="sc-section-title sc-clickable sc-btn-like"
              onClick={() => navigate("/DeficienciesIdentifiedService")}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  navigate("/DeficienciesIdentifiedService");
                }
              }}
              role="button"
              tabIndex={0}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "8px",
              }}
            >
              <img
                src="/new-icon.gif"
                alt="New"
                style={{
                  width: "24px",
                  height: "24px",
                  objectFit: "contain",
                  flexShrink: 0,
                }}
              />

              <span className="sc-title-bar" />
              <span>Application Status</span>
            </div>
            {/* 
            <div
              className="sc-section-title sc-clickable sc-btn-like"
              onClick={() => navigate("/Report")}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  navigate("/Report");
                }
              }}
            >
              <span className="sc-title-bar" />
              Report
            </div>  */}

            <div
              className="sc-section-title sc-clickable sc-btn-like"
              onClick={() => navigate("/RaiseyourConcern")}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  navigate("/RaiseyourConcern");
                }
              }}
            >
              <span className="sc-title-bar" />
              Raise your Concern
            </div>

          </div>
        </div>


        <div className={`sc-grid${visible ? " sc-grid-visible" : ""}`}>
          {filteredCards?.map((card, i) => {
            const clickable = isCardClickable(card.title);
            return (
              <div
                key={i}
                role="button"
                tabIndex={clickable ? 0 : -1}
                className={`sc-card ${!clickable ? "sc-card-disabled" : ""}`}
                style={{ "--card-index": i, cursor: clickable ? "pointer" : "not-allowed" }}
                onClick={() => clickable && openService(card)}
                onKeyDown={(e) => {
                  if (clickable && (e.key === "Enter" || e.key === " ")) {
                    e.preventDefault();
                    openService(card);
                  }
                }}
              >
                <div className="sc-card-accent" style={{ background: card.color }} />
                <div className="sc-card-top">
                  <div className="sc-icon-box" style={{ background: card.bg, color: card.color }}>{card.icon}</div>
                  <span className="sc-tag" style={{ background: card.bg, color: card.color }}>{card.tag}</span>
                </div>
                <div className="sc-card-body">
                  <h4 className="sc-card-title">{card.title}</h4>
                  <p className="sc-card-desc">{card.desc}</p>
                </div>
                <div className="sc-card-footer">
                  <span className="sc-apply-btn" style={{ color: card.color }}>
                    {clickable ? "Apply Now" : "Coming Soon"}
                  </span>
                  <span className="sc-arrow" style={{ color: card.color }}>→</span>
                </div>
              </div>
            );
          })}
        </div>





      </div>
    );

  /* ═══════════════════════════════════════════════════════════
     STEP FLOW
  ═══════════════════════════════════════════════════════════ */
  return (
    <div className="sc-root">
      <div className="flow-body">

        {/* ── Sidebar ── */}
        <aside className="flow-sidebar">
          <div className="step-list">
            {FILTERED_STEPS.map((step, i) => {
              const isActive = currentStep === i;
              /*
                isDone reads from API — never from navigation state.
                Clicking a step re-fetches API so it stays accurate.
              */
              const isDone = STEP_DONE_FROM_API[step.id] === true;

              return (
                <div
                  key={step.id}
                  role="button"
                  tabIndex={0}
                  className={`step-item step-clickable${isActive ? " step-active" : ""}${isDone ? " step-done" : ""}`}
                  onClick={() => jumpTo(i)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                      e.preventDefault();
                      jumpTo(i);
                    }
                  }}
                >
                  <div className="step-num-wrap">
                    <div
                      className="step-num"
                      style={
                        isActive
                          ? { background: step.groupColor, borderColor: step.groupColor, color: "#fff" }
                          : isDone
                            ? { background: "#0d9e76", borderColor: "#0d9e76", color: "#fff" }
                            : {}
                      }
                    >
                      {isDone ? <FaCheckCircle size={11} /> : i + 1}
                    </div>
                    {i < FILTERED_STEPS.length - 1 && (
                      <div
                        className="step-connector"
                        style={isDone ? { background: "#0d9e76" } : {}}
                      />
                    )}
                  </div>

                  <div className="step-label-wrap">
                    <div
                      className="step-lbl"
                      style={
                        isActive
                          ? { color: step.groupColor, fontWeight: 700 }
                          : isDone
                            ? { color: "#0d9e76" }
                            : {}
                      }
                    >
                      {step.label}
                    </div>
                    {/* ✅ isDone (API) checked first — Completed always wins even when active */}
                    {/* <div className="step-sub">
                      {isDone ? "Completed" : isActive ? "In Progress" : "Pending"}
                    </div> */}

                    <div className="step-sub">
                      {step.id === "preview"
                        ? (isActive ? "In Progress" : "")   // never show "Pending" for preview
                        : isDone
                          ? "Completed"
                          : isActive
                            ? "In Progress"
                            : "Pending"}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </aside>

        {/* ── Main ── */}
        <main className="flow-main">
          <div className="flow-step-hdr">
            <div
              className="flow-step-icon"
              style={{
                background: FILTERED_STEPS[currentStep].groupColor + "18",
                color: FILTERED_STEPS[currentStep].groupColor,
              }}
            >
              {FILTERED_STEPS[currentStep].icon}
            </div>
            <div style={{ flex: 1 }}>
              <h3 className="flow-step-title" style={{ color: selected.color }}>
                {FILTERED_STEPS[currentStep].label} — {activeCard}
              </h3>
            </div>
            <div
              className="flow-step-counter"
              style={{
                background: FILTERED_STEPS[currentStep].groupColor + "14",
                color: FILTERED_STEPS[currentStep].groupColor,
              }}
            >
              Step {currentStep + 1} of {FILTERED_STEPS.length}
            </div>
            <div>
              <button
                type="button"
                className="flow-nav-next"
                onClick={backToMainServices}
                style={{ background: selected.color }}
              >
                Back to services
              </button>
            </div>
          </div>

          <div className="flow-step-content">{renderContent()}</div>

          {/* ✅ Prev/Next always visible — no payment condition blocking */}
          <div className="flow-nav">
            <button className="flow-nav-prev" onClick={goPrev}>← Previous</button>
            <div className="flow-nav-dots" />
            {renderNextButton()}
          </div>
        </main>
      </div>
    </div>
  );
}